import React from 'react'
import {
  SkeletonBar as Bar,
  SkeletonSettingRow as Row,
  SkeletonSummaryCard
} from 'src/components/common/skeletons/SkeletonBar'

const Divider = () => <div className='h-px bg-zinc-200 w-full my-4' />

/**
 * Mirrors the shape of the discount form so the page does not jump when the real
 * content replaces it: method block, rules block, the two divided settings groups,
 * and the sticky summary card.
 */
export const DiscountFormSkeleton = () => (
  <div className='flex-1 flex w-full py-8 gap-16 px-12 items-start'>
    <div className='flex w-full justify-center'>
      <div className='flex flex-col w-full xl:min-w-[640px] max-w-[640px]'>
        <div className='flex flex-col gap-8'>
          {/* Method: icon + label, the large title input, then the hint callout */}
          <div className='flex flex-col gap-5'>
            <div className='flex flex-col gap-2'>
              <div className='flex items-center gap-2'>
                <Bar className='h-3.5 w-3.5 rounded' />
                <Bar className='h-3 w-24' />
              </div>
              <Bar className='h-7 w-2/3 rounded-md' />
            </div>
            <div className='flex items-start gap-2 py-2.5'>
              <Bar className='h-8 w-8 rounded-[10px]' />
              <div className='flex flex-col gap-1.5 w-full'>
                <Bar className='h-3 w-48' />
                <Bar className='h-3 w-3/4' />
              </div>
            </div>
          </div>

          {/* Application rules: heading over a couple of inputs */}
          <div className='flex flex-col gap-3 w-full'>
            <Bar className='h-3 w-28' />
            <Bar className='h-11 w-full rounded-xl' />
            <Bar className='h-11 w-full rounded-xl' />
          </div>
        </div>

        <Divider />

        <div className='flex flex-col'>
          <Row />
          <Row />
          <Row />
        </div>

        <Divider />

        <div className='flex flex-col'>
          <Row />
          <Row />
          <Row />
        </div>
      </div>
    </div>

    <SkeletonSummaryCard />
  </div>
)

export default DiscountFormSkeleton
